import { AppContent } from '../AppContent';

const idvWrapper: AppContent['idvWrapper'] = {
  idvWrapperContent: [
    {
      serviceName: 'Business Internet Banking',
      contactNo: '0345 300 0268',
      ukCode: '+44',
      uk: 'United Kingdom',
      technicalErrorHref: '/technical-error',
      loaderMessage: 'Just a minute...',
      submitRegistrationPath: '/submit-your-registration',
      hardFailurePath: '/hard-failure',
      threeStepsToRegisterIdVerifyPath: '/three-steps-to-register-id-verify',
      dialogTitle: 'Leave page?',
      dialogContent: `This will end your session and we won't save the details you've entered.`,
      noBtnLabel: 'Stay',
      yesBtnLabel: 'Leave page',
      yesBtnLink: '/get-started',
      idvStartPath: '/idv/proofOfIdentity',
      idvErrorPath: '/idv-error',
    },
  ],
};

export default idvWrapper;
